import Laboratories from "../components/pages/Laboratories";

export default Laboratories;
